import { createSlice } from "@reduxjs/toolkit";

const cancellationFilterSlice = createSlice({
  name: "cancellationFilter",
  initialState: {
    status: "",
    search: "",
  },
  reducers: {
    setCancellationStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setCancellationSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearCancellationSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const {
  setCancellationStatusFilter,
  setCancellationSearchFilter,
  clearCancellationSearchFilter,
} = cancellationFilterSlice.actions;

export const selectCancellationState = (state) => state.cancellationFilter;

export default cancellationFilterSlice.reducer;
